import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

export const NaValue = () => (
    <Text
        fontVariant="input2"
        color={colorsPalettes.carbon[500]}
    >
        —
    </Text>
);
